export function placeholderToZero(input) {
  let output = input.replace(/#/g, "0");
  return output;
}
